"use strict"

import React, { useState } from "react"
import { Button } from "react-bootstrap"
import { FormattedMessage, useIntl } from "react-intl"

import { deleteObject } from "../../../Loaders"
import { logToServer } from "../../../ErrorBoundary"
import { withInventoryConfig } from "../../../config/InventoryConfigProvider"
import ModalReceiveProcurementItem from "./modals/ModalReceiveProcurementItem"

function ProcurementItemButtons({ row = {}, user_permissions = [], getProcurementItems, onItemReceived }) {
  const intl = useIntl()
  const deleteProcurementItem = () => {
    if (!confirm(intl.formatMessage({ id: "inventory.are-you-sure-delete-item" }))) {
      return false
    }

    deleteObject(`/laboratory/inventory/procurement-item/${row.id}/`, false, false)
      .then((_) => {
        getProcurementItems()
      })
      .catch((error) => {
        console.error(error)
        logToServer(error)
        alert(intl.formatMessage({ id: "inventory.error-delete-item" }))
      })
  }

  const [receiveModalVisible, setReceiveModalVisible] = useState(false)
  return (
    <>
      <Button
        variant={"outline-primary"}
        style={{ margin: "1px" }}
        size={"sm"}
        disabled={!user_permissions.includes("change_inventoryitem")}
        onClick={(_) => setReceiveModalVisible(true)}
      >
        <span className={"fa fa-thumbs-o-up"} />
        &nbsp;&nbsp;
        <FormattedMessage id={"stock.receive"} />
      </Button>
      &nbsp;&nbsp;
      <Button
        variant={"outline-primary"}
        style={{ margin: "1px" }}
        size={"sm"}
        disabled={!user_permissions.includes("change_inventoryitem")}
        onClick={deleteProcurementItem}
      >
        <span className={"fa fa-trash-o text-danger"} />
        &nbsp;&nbsp;
        <FormattedMessage id={"general.delete"} />
      </Button>
      {receiveModalVisible && row?.id && user_permissions.includes("change_inventoryitem") && (
        <ModalReceiveProcurementItem
          procurement_item={row}
          show={receiveModalVisible}
          onHide={() => setReceiveModalVisible(false)}
          onSuccess={(data) => {
            setReceiveModalVisible(false)
            getProcurementItems()
            onItemReceived && onItemReceived(data)
          }}
        />
      )}
    </>
  )
}

export default withInventoryConfig(ProcurementItemButtons)
